/**
* @requires _jquery.js"
* @requires ./../assets/slick/_slick.js
* @requires ./../assets/waypoints/_waypoints.js
* @requires ./../assets/mixitup3/_mixitup.min.js
* @requires ./../assets/mixitup3/_mixitup-pagination.min.js
* @requires ./../assets/magnific/_jquery.magnific-popup.min.js
* @requires ./../assets/accessibility/_accessibility.js
* @requires ./../assets/responsivetabs/_script.js"
* @requires ./../assets/mousewheel/_mousewheel.js
* @requires ./../assets/js-scrollpane/_js-scrollpane.js
* @requires ./../assets/match-height/_matchHeight.js
* @requires ./../include/mobile-menu/_mobile-menu.js
* @requires ./../include/header-row/_header-row.js
* @requires ./../include/defualt-content/_defualt-content.js
* @requires ./../include/home-sidebar/_home-sidebar.js
* @requires ./../include/home-main/_home-main.js
* @requires ./../include/story-right/_story-right.js
* @requires ./../include/story-left/_story-left.js
* @requires ./../include/story-main/_story-main.js
* @requires ./../include/story-subjects/_story-subjects.js
* @requires ./../include/story-subjects-full/_story-subjects-full.js
* @requires ./../include/lexicon-lobi/_lexicon-lobi.js
* @requires ./../include/interpretation-right/_interpretation-right.js
* @requires ./../include/interpretation-main/_interpretation-main.js
* @requires ./../include/interpretation-left/_interpretation-left.js
* @requires ./../include/taxonomy-main/_taxonomy-main.js
* @requires ./../include/taxonomy-sidebar/_taxonomy-sidebar.js
* @requires ./../include/interpretation-lobi/_interpretation-lobi.js
* @requires ./../include/writer-right/_writer-right.js
* @requires ./../include/writer-main/_writer-main.js
* @requires ./../include/defualt-content-sidebar/_defualt-content-sidebar.js
* @requires ./../include/blog-roll-type3/_blog-roll-type3.js
* @requires ./../include/no-results/_no-results.js
* @requires ./../include/section-filter-search/_section-filter-search.js
* @requires ./../include/blog-roll-term/_blog-roll-term.js
* @requires ./../include/blog-roll-type4/_blog-roll-type4.js
/*script*/

$(document).ready(function() {
    // Waypoints
    var waypoints = $('.lexicon-nav').waypoint({
        handler: function(direction) {
            console.log(direction);
            $('.lexicon-nav').toggleClass('stick-it');
        }
    })
    // Access plugin
    $('#access-plug').accessPlug({
        contrastLight: false,
        lang : "he",
        title : "סרגל נגישות",
    });
    // Functions
    homeMain();
    storyMain();
    storyRight();
    storySubjects();
    storySubjectsFull();
    lexiconLobi();
    taxonomySidebar();
    mobileMenu();
    sectionFilterSearch();
    writerMain();
});
